import React, { useState } from "react";
import Logo from "../components/Logo";
import TextInput from "../components/TextInput";
import { Spinner } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { useError } from "../contexts/ErrorContext";
import UserConfirmationModal from "../components/UserConfirmationModal";
import LoadingOverlay from "../components/LoadingOverlay";

export default function Register() {
  const { setErrors } = useError();
  const [newUser, setNewUser] = useState({});
  const [enableSpinner, setEnableSpinner] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [qrCodeBytes, setQrCodeBytes] = useState("");
  const [enableOverlay, setEnableOverlay] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setEnableSpinner(true);
    axiosInstance
      .post("/v51/sessions/register", newUser)
      .then((res) => {
        if (res.status === 201) {
          setEnableSpinner(false);
          setQrCodeBytes(res.data.qrCode);
          setOpenConfirmationModal(true);
        }
      })
      .catch((e) => {
        setEnableSpinner(false);
        setErrors([
          e.response?.data?.message ||
            "An internal error occurred, please try again later.",
        ]);
      });
  };

  const handleConfirmationSubmit = (TOTP, emailPin) => {
    setEnableOverlay(true);
    axiosInstance
      .post("/v51/sessions/register/confirm", {
        email: newUser.email,
        emailPin: emailPin,
        appCode: TOTP,
      })
      .then((res) => {
        if (res.data?.success) {
          setEnableOverlay(false);
          navigate("/login");
        }
      })
      .catch((e) => {
        setEnableOverlay(false);
        setErrors([
          e.response?.data?.message ||
            "An internal error occurred, please try again later.",
        ]);
      });
  };

  return (
    <>
      <section className="">
        <div className="mx-auto flex min-h-screen flex-col items-center justify-center px-6 py-8 lg:py-0">
          <a
            href="#"
            className="mb-6 flex items-center text-2xl font-semibold text-gray-900 dark:text-white"
          >
            <Logo className="mr-2 h-36" />
          </a>
          <div className="w-full rounded-lg bg-white shadow dark:border dark:border-gray-700 dark:bg-gray-800 sm:max-w-md md:mt-0 xl:p-0">
            <div className="space-y-4 p-6 sm:p-8 md:space-y-6">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white md:text-2xl">
                Create a new account
              </h1>
              <form
                className="space-y-4 md:space-y-6"
                onSubmit={handleSubmit}
                action="#"
              >
                <TextInput
                  label="Your email"
                  type="email"
                  value={newUser.email}
                  setValue={(event) =>
                    setNewUser({ ...newUser, email: event.target.value })
                  }
                  name="email"
                  placeholder="name@company.com"
                />
                <TextInput
                  label="Last name"
                  type="text"
                  value={newUser.lastName}
                  setValue={(event) =>
                    setNewUser({ ...newUser, lastName: event.target.value })
                  }
                  name="lastName"
                  placeholder="Last name"
                />
                <TextInput
                  label="First name"
                  type="text"
                  value={newUser.firstName}
                  setValue={(event) =>
                    setNewUser({ ...newUser, firstName: event.target.value })
                  }
                  name="firstName"
                  placeholder="First name"
                />
                <TextInput
                  label="Company name"
                  type="text"
                  value={newUser.company}
                  setValue={(event) =>
                    setNewUser({ ...newUser, company: event.target.value })
                  }
                  name="company"
                  placeholder="Company name"
                />
                <TextInput
                  label="Job title"
                  type="text"
                  value={newUser.jobTitle}
                  setValue={(event) =>
                    setNewUser({ ...newUser, jobTitle: event.target.value })
                  }
                  name="jobTitle"
                  placeholder="Job title"
                />
                <button
                  class="mb-2 me-2 rounded-lg bg-gray-800 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-900
                     focus:outline-none focus:ring-4 focus:ring-gray-300
                     dark:border-gray-700
                     dark:bg-gray-50 dark:text-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                >
                  {enableSpinner ? (
                    <Spinner aria-label="Default status example" />
                  ) : (
                    "Sign up"
                  )}
                </button>
                <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                  Already got an account?{" "}
                  <a
                    onClick={() => navigate("/login")}
                    className="text-primary-600 dark:text-primary-500 font-medium hover:underline"
                  >
                    Sign in
                  </a>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
      <UserConfirmationModal
        qrCodeBytes={qrCodeBytes}
        show={openConfirmationModal}
        onClose={() => setOpenConfirmationModal(false)}
        handleSubmit={handleConfirmationSubmit}
      />
      <LoadingOverlay
        enabled={enableOverlay}
        message="Your confirming crendentials"
      />
    </>
  );
}
